import { cn } from '@/lib/utils'

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span className={cn('block h-5 animate-pulse rounded bg-black/10', className)} {...props} />
)
